export enum AgreementType {
  'kredyt',
  'przedplacona wartościowa',
  'przedpłacona ilościowa'
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/dictonaries/agreement-type.enum.ts